// SelectedListItems from VerticalListItems

import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type Fleet } from '../domain/fleet';
import { type Vehicle } from '../domain/vehicle';


export interface PendingFleetSlice {
    fleet: Fleet;
    fixedSlots?: number;
    floatingSlots?: number;
}


const initialState: PendingFleetSlice = {
    fleet: {
        name: '',
        vehicles: [],
    }, 
};

const pendingFleetSlice = createSlice({
    initialState,
    name: 'pendingFleet',
    reducers: {
        clearPendingFleet: () => {
            return initialState;
        },
        setFixedSlots: (state, action: PayloadAction<number>) => {
            state.fixedSlots = action.payload;
            return state;
        },
        setFloatingSlots: (state, action: PayloadAction<number>) => {
            state.floatingSlots = action.payload;
            return state;
        },
        setPendingFleet: (state, action: PayloadAction<Fleet>) => {
            state.fleet = action.payload;
            
            return state;
        },
        setVehicles: (state, action: PayloadAction<Vehicle[]>) => {
            state.fleet.vehicles = action.payload;
            return state;
        },
        updatePendingFleetProps: (state, action: PayloadAction<{ key: string, value: unknown }>) => {
            const { key, value } = action.payload;
            state.fleet = {
                ...state.fleet,
                [key]: value,
            };
            return state;
        }
    },
});

export const { clearPendingFleet, setFixedSlots, setFloatingSlots, setPendingFleet, updatePendingFleetProps } = pendingFleetSlice.actions;

export default pendingFleetSlice.reducer;